<template>
    <transition name="slide">
        <div class="bg-surface-secondary w-100">
            <header class="bg-surface-primary border-bottom">
                <div class="container-fluid py-3">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="d-flex align-items-center gap-4">
                                <div>
                                    <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                                </div>
                                <div class="vr opacity-20 my-1"></div>
                                <div>
                                    <h1 class="h4 ls-tight">Paquete - {{ data.type }}{{ data.id }}</h1>
                                    <p class="text-sm text-muted mb-0">Administre los roles de su cuenta y otorgue a sus
                                administradores solo los permisos necesarios.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main class="py-6 bg-surface-secondary">
                <div class="container-fluid vstack gap-5">
                    <div class="w-100 pt-5" v-if="loading">
                        <div class="text-center">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-else>
                        <div class="col-lg-6">
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Cliente: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <label class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;">
                                        <router-link v-if="data.user" :to="{ name: 'UserDetail', params: { role: data.user.role.name, id: data.user.id }}" class="text-decoration-none">
                                            {{data.user.name}} - {{`${data.user.type}${data.user.id}`}}
                                            <i class="fa-solid fa-square-arrow-up-right"></i>
                                        </router-link>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Valor: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="Number(data.value || 0).toFixed(2)">
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Remitente: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.shipper">
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Embalaje: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.packing ? data.packing.name : ''">
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Peso: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="Number(data.weight || 0).toFixed(2)">
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Dimensiones: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="`${Number(data.lengthy || 0).toFixed(2)} x ${Number(data.width || 0).toFixed(2)} x ${Number(data.tall || 0).toFixed(2)}`">
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Descripción: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <div v-bind="attrs" v-on="on" v-if="data.description[0]">
                                                <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.description[0]">
                                            </div>
                                        </template>
                                        <small>
                                            <div v-for="(description, key) in  data.description" :key="key">{{ description }}</div>
                                        </small>
                                    </v-tooltip>
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Tracking: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.tracking">
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Impuesto: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.tax ? Number((data.tax.value*100) || 0).toFixed(2) + '%' : ''">
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Piezas: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.pieces">
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Peso Volumétrico: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="Number(data.volumetric_weight || 0).toFixed(2)">
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Creado Por: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <label class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;">
                                        <router-link v-if="data.user_created" :to="{ name: 'UserDetail', params: { role: data.user_created.role.name, id: data.user_created.id }}" class="text-decoration-none">
                                            {{data.user_created.name}} - {{`${data.user_created.type}${data.user_created.id}`}}
                                            <i class="fa-solid fa-square-arrow-up-right"></i>
                                        </router-link>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Actualizado Por: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <label class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;">
                                        <router-link v-if="data.user_updated" :to="{ name: 'UserDetail', params: { role: data.user_updated.role.name, id: data.user_updated.id }}" class="text-decoration-none">
                                            {{data.user_updated.name}} -{{`${data.user_updated.type}${data.user_updated.id}`}}
                                            <i class="fa-solid fa-square-arrow-up-right"></i>
                                        </router-link>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Creado: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.created_at | DATETIME">
                                </div>
                            </div>
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Actualizado: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.updated_at | DATETIME">
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">AWB: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.awb ? data.awb.awb : ''">
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">HAWB: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <input type="text" readonly class="form-control form-control-sm text-muted bg-white" style="font-size: 11px; height: 31px; display: flex; align-items: center;" :value="data.hawb ? data.hawb.hawb : ''">
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Archivos Adjuntos: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <div class="py-3"></div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-1 col-md-2 col-sm-3 col-4" v-for="(item, index) in data.files">
                                    <img :src="`${item.path}`" class="img-fluid">
                                </div>
                            </div>
                        </div>
                    </div>
                    <payments/>
                    <history/>
                </div>
            </main>
        </div>
    </transition>
</template>
<script>
import Payments from './forms/Payments'
import History from './forms/History'
export default {
    components: { Payments, History },
    data() {
        return {
            loading: true,
            data: {},
            id: this.$route.params.id,
        }
    },
    mounted() {
        this.INIT()
    },
    methods: {
        INIT: function () {
            let vue = this
            axios({ url: '/packages/' + vue.id, method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
                .finally((resp) => {
                    vue.loading = false
                })
        }
    },
}
</script>